const React = require('react');
const LayoutB = require('../../../dumb/Layout/B');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');
const withState = require('../../../../utils/withState');
const MaintenanceMode = require('./MaintenanceMode');
const Subsystem = require('./Subsystem');
const Orcales = require('./Orcales');
const Cryptocurrencies = require('./Cryptocurrencies');
const Wallets = require('./Wallets');
const ActiveAuctions = require('./ActiveAuctions');
const MailSystem = require('./MailSystem');
const {account$} = require("../../../../emitters/account");


function FieldA({
  label,
  children,
  ...props
}) {
  return (
    <div
      {...props}
      className={props.className || ''}
    >
      <div className="cA4A7AC f16 fw5">{label}</div>
      <div className="mt15">{children}</div>
    </div>
  );
}


module.exports = withState(() => {
  return ({account}) => {

    const isAdmin = account.admin;

    return (
      <LayoutB className="pr30">
        <HeaderA>
          <CaptionA>Status</CaptionA>
        </HeaderA>
        {isAdmin && (
          <FieldA
            label="Maintenance"
            className="mt30"
          >
            <MaintenanceMode/>
          </FieldA>
        )}
        <FieldA
          label="Active auctions"
          className="mt40"
        >
          <ActiveAuctions/>
        </FieldA>
        {isAdmin && (
          <>
            <FieldA
              label="Mail system"
              className="mt40"
            >
              <MailSystem/>
            </FieldA>
            <FieldA
              label="Cryptocurrencies"
              className="mt40"
            >
              <Cryptocurrencies/>
            </FieldA>
            <FieldA
              label="Wallets"
              className="mt40"
            >
              <Wallets/>
            </FieldA>
          </>
        )}
        {/*<div className="mt40 o10">*/}
        {/*  <FieldA*/}
        {/*    label="Subsystem"*/}
        {/*    className="w550"*/}
        {/*  >*/}
        {/*    <Subsystem/>*/}
        {/*  </FieldA>*/}
        {/*  <FieldA*/}
        {/*    className="mt40"*/}
        {/*    label={(*/}
        {/*      <div className="layoutRow fhaS fvaC">*/}
        {/*        <div className="w180">Oracles</div>*/}
        {/*        <div>MemPool rate</div>*/}
        {/*      </div>*/}
        {/*    )}*/}
        {/*  >*/}
        {/*    <Orcales/>*/}
        {/*  </FieldA>*/}
        {/*</div>*/}
      </LayoutB>
    );
  }
}, {
  account: account$
});
